import { Stack } from "@skailer-com/uikit";
import { ReactNode } from "react";

interface PreboardingCardProps {
  children?: ReactNode;
}

export function PreboardingCard({ children }: PreboardingCardProps) {
  return <Stack className={"bg-light rounded-xs px-6 py-2 shadow-sm"}>{children}</Stack>;
}
